
import Amount from '@/types/Amount';

export default class CollectedItem {
	public hasSticker: boolean;
	public purchaseAmount: Amount;
	public estimatedValueAmount: Amount;
}
